import React, { JSXElementConstructor } from 'react';
import { Grid } from '@material-ui/core';
import { AnyAttachment, PostAttachmentProps } from '../NewsfeedModels';
interface AttachmentsProps {
    items: AnyAttachment[];
    mapping: { [key: string]: JSXElementConstructor<PostAttachmentProps<any>> };
}

export default function Attachments({ items = [], mapping }: AttachmentsProps) {
    return (
        <Grid container style={{ marginBottom: 10 }}>
            {items.map((item, index) => {
                const itemType = item.type;
                const Attachment = mapping[itemType] as JSXElementConstructor<PostAttachmentProps<typeof item.content>>;
                return <Attachment key={index} content={item.content} />;
            })}
        </Grid>
    );
}
